import { type AssetFileType } from 'types/AssetFileType';
import { DocumentType } from 'types/DocumentType';

/**
 * @class DocumentSchema
 * @description
 * The DocumentSchema class is used to define the base default schema for a document.
 */
export class DocumentSchema {
    name: string;
    type: DocumentType | AssetFileType = DocumentType.DEFAULT;
}
